import React from 'react'
import { makeStyles, Dialog, IconButton, Typography } from '@material-ui/core';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CloseIcon from "@material-ui/icons/Close";
import { LibraryItem } from '../../../../entities/LibraryItem';

const useStyles = makeStyles(() => ({
    moveContent: {
        height: "100%",
        width: "100%",
        overflow: "hidden",
    },
    moveContentTitle: {
        height: "48px",
        backgroundColor: "#f1f1f1",
        marginRight: "2px",
    },
    movePopperTitle: {
        display: "inline-block",
        color: "#777",
        fontWeight: 500,
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: "170px",
        textOverflow: "ellipsis",
        fontFamily: "Roboto, Helvetica",
        verticalAlign: "middle",
    },
}));

interface MobileMoveMenuProps {
    open: boolean;
    onClose: () => void;
    disabled: boolean;
    parentFolder?: LibraryItem;
    handleBackClick: (assetId:string | undefined) => void;
}

export function MobileMoveMenu(props: React.PropsWithChildren<MobileMoveMenuProps>) {
    const { open, parentFolder } = props;
    const classes = useStyles();

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={props.onClose}
        >
            <div className={classes.moveContent}>
                <div className={classes.moveContentTitle}>
                    <div style={{ margin: "0 8px", paddingTop: "8px" }}>
                        {parentFolder && (
                            <IconButton
                                style={{ marginLeft: "-4px", marginTop: "-4px" }}
                                aria-label="Back"
                                onClick={() => props.handleBackClick(parentFolder.parentId)}
                                disabled={props.disabled}
                            >
                                <ArrowBackIcon fontSize="small" />
                            </IconButton>
                        )}
                        <Typography variant="subtitle1" gutterBottom className={classes.movePopperTitle}>
                            {parentFolder ? parentFolder.name : "My Library"}
                        </Typography>
                    </div>
                    <IconButton
                        aria-label="Close"
                        onClick={props.onClose}
                        style={{
                            top: "1px",
                            right: "1px",
                            position: "absolute",
                        }}
                        disabled={props.disabled}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
                <div style={{height: "calc(100% - 48px)"}}>
                    {props.children}
                </div>
            </div>
        </Dialog>
    );
}